import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/LodingContext";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../components/MaterialInput";
import {
  allProductsDropdown,
  completedDeliveries,
  createComplaints,
  getCompalaintsCustomerQuery,
  GetComplaintById,
  manageComplaintsState,
  manageComplaintsStateMange,
  severityLevelOption,
  updateComplaints,
} from "../data";
import MaterialSelect from "../../../../components/MasterSelect";
import ImageSelector from "../../../components/ImageSelector";
import BASEURL from "../../../../pages/Utils/Baseurl";
import request from "graphql-request";
import { useMutation } from "@apollo/client";
import meadiaURL from "../../../../pages/Utils/url";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";

const ManageComplaintsForms = () => {
  const [manageComplaintsData, dispatch] = useReducer(
    manageComplaintsStateMange,
    manageComplaintsState
  );

  const [createComplaintsData, { loading, error }] =
    useMutation(createComplaints);
  const [updateComplaintsData] = useMutation(updateComplaints);
  const [inputDisble, setInputDisble] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const formType = location?.state?.type;
  const rowId = location?.state?.rowId;
  const [productImgUrl, setProductImgUrl] = useState(null);
  const [salesOrderData, setSalesOrderData] = useState([]);
  const [productData, setProductData] = useState([]);
  const { userId } = useAuthData();

  useEffect(() => {
    fetchProductAndSalesdata();
  }, []);

  // change formType Add or edit or View usi ng input disble or enable
  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  useEffect(() => {
    if (rowId) {
      fetchComplainById(rowId);
    }
  }, [rowId]);

  //image change
  const handleImageSelect = (file) => {
    dispatch({ value: file, name: "attachment" });
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  //fetch by id form data
  const fetchComplainById = async (rowId) => {
    const response = await request(BASEURL, GetComplaintById, {
      complaintId: rowId,
    });
    const value = response?.complaintById?.data;

    dispatch({
      value: value?.complaintId, // Use the correct key from the response
      name: "complaintID",
    });

    dispatch({
      value: value?.customerName, // customerName is a string
      name: "customerName",
    });

    let deliveriesList = salesOrderData;
    if (!deliveriesList || deliveriesList.length === 0) {
      try {
        const delivRes = await request(BASEURL, completedDeliveries);
        if (delivRes?.completedDeliveries?.success) {
          deliveriesList =
            delivRes.completedDeliveries.data?.map((delivery) => ({
              label: delivery.salesOrder?.soNumber,
              value: delivery.salesOrder?.id,
              deliveryId: delivery.id,
            })) || [];
          setSalesOrderData(deliveriesList);
        }
      } catch (e) {
        console.error("Error fetching completed deliveries in fetchComplainById:", e);
      }
    }

    const rawSalesOrderId = value?.salesOrder?.id;
    const soNumber = value?.salesOrder?.soNumber;

    const matchedDelivery = deliveriesList?.find(
      (d) =>
        String(d.deliveryId) === String(rawSalesOrderId) ||
        (soNumber && d.label === soNumber) ||
        String(d.value) === String(rawSalesOrderId)
    );

    const actualSalesOrderId = matchedDelivery?.value || rawSalesOrderId;

    dispatch({
      value: {
        value: actualSalesOrderId,
        deliveryId: matchedDelivery?.deliveryId || rawSalesOrderId,
        label: soNumber || matchedDelivery?.label || "",
      },
      name: "soNumber",
    });

    const targetProductId = value?.productId || value?.productID;
    let productOptions = [];
    let matchedProduct = null;

    const candidateIds = [actualSalesOrderId, rawSalesOrderId].filter(Boolean);
    const uniqueCandidateIds = [...new Set(candidateIds.map(Number))];

    for (const candId of uniqueCandidateIds) {
      if (!candId) continue;
      try {
        const soResponse = await request(BASEURL, getCompalaintsCustomerQuery, {
          id: candId,
        });
        const soData = soResponse?.getSalesorderLite?.data?.[0];
        const products = soData?.salesorderproductSet || [];
        if (products.length > 0) {
          productOptions = products.map((item) => {
            const name = item?.product?.productName || "";
            const id = item?.product?.id || "";
            const label = name && id ? `${name} (${id})` : name;
            return {
              label: label,
              value: id,
              id: id,
              productName: name,
            };
          });

          setProductData(productOptions);

          if (targetProductId) {
            matchedProduct = productOptions.find(
              (p) => String(p.id || p.value) === String(targetProductId)
            );
          }
          if (matchedProduct) break;
        }
      } catch (err) {
        console.error("Error fetching sales order products in fetchComplainById:", err);
      }
    }

    if (!matchedProduct && targetProductId) {
      try {
        const prodRes = await request(BASEURL, allProductsDropdown);
        const allList = prodRes?.allProductsDropdown?.data || [];
        const fallbackMatch = allList.find(
          (p) => String(p.id) === String(targetProductId)
        );
        if (fallbackMatch) {
          const name = fallbackMatch.productName || "";
          const id = fallbackMatch.id || targetProductId;
          const label = name ? `${name} (${id})` : String(id);
          matchedProduct = {
            label: label,
            value: id,
            id: id,
            productName: name,
          };
          setProductData((prev) => {
            if (!prev.some((p) => String(p.value) === String(id))) {
              return [...prev, matchedProduct];
            }
            return prev;
          });
        }
      } catch (err) {
        console.error("Error fetching fallback product in fetchComplainById:", err);
      }
    }

    const resolvedProductName =
      matchedProduct?.productName || value?.productName || "";
    const resolvedProductLabel = matchedProduct
      ? matchedProduct.label
      : resolvedProductName && targetProductId
        ? `${resolvedProductName} (${targetProductId})`
        : resolvedProductName || targetProductId || "";

    dispatch({
      value: targetProductId
        ? {
          value: targetProductId,
          label: resolvedProductLabel,
        }
        : "",
      name: "product",
    });

    dispatch({
      value: value?.productPurchaseDate || value?.salesOrder?.orderDate, // Use productPurchaseDate if available, fallback to orderDate
      name: "productPurchaseDate",
    });

    dispatch({
      value: value?.complaintDate,
      name: "complaintDate",
    });

    dispatch({
      value: value?.description,
      name: "complaintDescription",
    });

    setProductImgUrl(
      value?.attachment ? `${meadiaURL}media/${value?.attachment}` : null
    );

    dispatch({
      value: {
        value: capitalizeFirstLetter(value?.severityLevel),
        label: capitalizeFirstLetter(value?.severityLevel),
      }, // Map severityLevel directly
      name: "severityLevel",
    });
  };

  // handle submit function
  const handleSubmit = async () => {
    setCirleLoading(true);
    const value = {
      customerName: manageComplaintsData?.customerName,
      salesOrderId: manageComplaintsData?.soNumber?.deliveryId,
      productId: manageComplaintsData?.product?.value,
      productPurchaseDate: manageComplaintsData?.productPurchaseDate,
      complaintDate: manageComplaintsData?.complaintDate,
      description: manageComplaintsData?.complaintDescription,

      severityLevel: manageComplaintsData?.severityLevel.value,
    };
    if (formType == "add") {
      await onSubmit(value);
    } else if (formType == "edit") {
      await onUpdate(value);
    }
    setCirleLoading(false);
  };

  const onSubmit = async (value) => {
    try {
      const response = await createComplaintsData({
        variables: {
          input: {
            userId: userId,
            ...value,
          },
          attachment: manageComplaintsData?.attachment || null,
        },
        context: { hasUpload: true },
      });
      const status = response?.data?.createComplaint?.success;
      const message = response?.data?.createComplaint?.message;

      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/manage-complaints");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error creating complaint:", error);
    }
  };

  // edit function
  const onUpdate = async (value) => {
    const { attachment, ...otherValues } = value;

    try {
      // Prepare variables for the mutation
      const variables = {
        input: {
          ...otherValues,
          complaintId: rowId,
          attachment: attachment?.name ? attachment : null,
        },
      };

      // Call the mutation
      const res = await updateComplaintsData({
        variables,
        context: attachment ? { hasUpload: true } : {}, // Enable file upload context only if attachment exists
      });

      // Extract the response data
      const status = res?.data?.updateComplaint?.success;
      const message = res?.data?.updateComplaint?.message;

      // Show feedback based on the response
      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message || "Complaint updated successfully.",
          showConfirmButton: true,
        }).then(() => {
          navigate("/manage-complaints");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message || "Failed to update complaint. Please try again.",
          showConfirmButton: true,
        });
      }
    } catch (error) {
      // Handle any unexpected errors
      console.error("Error updating complaint:", error);
      Swal.fire({
        position: "top",
        icon: "error",
        title: "An error occurred while updating the complaint.",
        showConfirmButton: true,
      });
    }
  };

  const fetchProductAndSalesdata = () => {
    setCirleLoading(true);
    request(BASEURL, completedDeliveries)
      .then((res) => {
        console.log(res, "res");

        const data = res?.completedDeliveries;

        if (data?.success && data?.data?.length > 0) {
          const newData = data?.data?.map((delivery) => ({
            label: delivery.salesOrder?.soNumber,
            value: delivery.salesOrder?.id,
            deliveryId: delivery.id
          }));

          setSalesOrderData(newData);
        } else {
          setProductData([]);
          setSalesOrderData([]);
        }
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  //On SO number change
  const handleSOChange = async (selected) => {
    dispatch({ value: selected, name: "soNumber" });

    if (selected) {
      const response = await request(BASEURL, getCompalaintsCustomerQuery, {
        id: Number(selected.value),
      });

      const value = response?.getSalesorderLite?.data[0];
      dispatch({ value: value?.customer?.customerName, name: "customerName" });
      dispatch({ value: value?.orderDate, name: "productPurchaseDate" });

      const products = value?.salesorderproductSet || [];

      const productOptions = products.map((product) => {
        const name = product?.product?.productName || "";
        const id = product?.product?.id || "";
        const label = name && id ? `${name} (${id})` : name;
        return {
          label: label,
          value: id,
          id: id,
          productName: name,
        };
      });

      setProductData(productOptions);
    } else {
      dispatch({ value: "", name: "product" });
      dispatch({ value: "", name: "customerName" });
      dispatch({ value: "", name: "productPurchaseDate" });
      setProductData([]);
    }

    dispatch({ value: "unchecked", name: "productStatus" });
  };

  const handleDownload = async () => {
    const imageUrl = productImgUrl;
    if (!imageUrl) return;

    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "attachment_image.jpg";
    a.click();
    URL.revokeObjectURL(url);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      manageComplaintsData?.soNumberStatus === "success" &&
      manageComplaintsData.customerNameStatus === "success" &&
      manageComplaintsData.productStatus === "success" &&
      manageComplaintsData.productPurchaseDateStatus === "success" &&
      manageComplaintsData.complaintDateStatus === "success" &&
      manageComplaintsData.severityLevelStatus === "success" &&
      manageComplaintsData.complaintDescriptionStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  return (
    <DashboardLayout>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
      >
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden", // prevent scrollbars
            p: 0,
          }}
        >
          {ImageSelector ? (
            <img
              src={productImgUrl}
              alt="Product"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "8px",
                objectFit: "contain",
                display: "block",
              }}
            />
          ) : (
            <MaterialTypography>No image available</MaterialTypography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
          {formType == "view" ? (
            <Button onClick={handleDownload}>Download</Button>
          ) : (
            ""
          )}
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add"
                    : formType == "edit"
                      ? "Edit"
                      : "View"}{" "}
                  Manage Complaints Details
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              {(formType === "view" || formType === "edit") && (
                <Grid size={{ lg: 6, xs: 6, sm: 6, md: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Complaint ID <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={manageComplaintsData?.complaintID}
                    name="complaintID"
                    placeholder="Enter Complaint ID"
                    disabled={true}
                    onChange={(e) =>
                      dispatch({ value: e?.target?.value, name: "complaintID" })
                    }
                    error={
                      manageComplaintsData.complaintIDStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      manageComplaintsData.complaintIDStatus === "success"
                        ? true
                        : false
                    }
                  />
                </Grid>
              )}
              <Grid size={{ lg: 6, xs: 6, sm: 6, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    SO Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="soNumber"
                  value={manageComplaintsData?.soNumber}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={salesOrderData}
                  // onChange={(e, s) => dispatch({ value: e, name: "soNumber" })}
                  onChange={handleSOChange}
                  isClearable
                  error={
                    manageComplaintsData?.soNumberStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    manageComplaintsData?.soNumberStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 6, sm: 6, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={manageComplaintsData?.customerName}
                  name="customerName"
                  placeholder="Enter customer name"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "customerName" })
                  }
                  error={
                    manageComplaintsData.customerNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    manageComplaintsData.customerNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 6, xs: 6, sm: 6, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="product"
                  value={manageComplaintsData?.product}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={productData}
                  onChange={(e, s) => dispatch({ value: e, name: "product" })}
                  isClearable
                  error={
                    manageComplaintsData.productStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    manageComplaintsData.productStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 6, sm: 6, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Purchase Date{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="date"
                  value={manageComplaintsData?.productPurchaseDate}
                  name="productPurchaseDate"
                  placeholder="Enter Product Code"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "productPurchaseDate",
                    })
                  }
                  error={
                    manageComplaintsData.productPurchaseDateStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    manageComplaintsData.productPurchaseDateStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 6, sm: 6, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Complaint Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="date"
                  value={manageComplaintsData?.complaintDate}
                  name="complaintDate"
                  placeholder="Enter Product Code"
                  disabled={inputDisble}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0], // sets max date as today
                  }}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "complaintDate",
                    })
                  }
                  error={
                    manageComplaintsData.complaintDateStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    manageComplaintsData.complaintDateStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 6, sm: 6, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Severity Level <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="severityLevel"
                  value={manageComplaintsData?.severityLevel}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={severityLevelOption?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e, s) =>
                    dispatch({ value: e, name: "severityLevel" })
                  }
                  isClearable
                  error={
                    manageComplaintsData.severityLevelStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    manageComplaintsData.severityLevelStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 6, sm: 6, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Complaint Description{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={3}
                  value={manageComplaintsData?.complaintDescription}
                  name="complaintDescription"
                  placeholder="Enter Complaint Description"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "complaintDescription",
                    })
                  }
                  error={
                    manageComplaintsData.complaintDescriptionStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    manageComplaintsData.complaintDescriptionStatus ===
                      "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 6, xs: 12, sm: 6, md: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Attachment
                  </MaterialTypography>
                </MaterialBox>

                <FullscreenIcon
                  fontSize="small"
                  className="viewIcon"
                  onClick={() => {
                    setDialogOpen(true);
                  }}
                  style={{
                    cursor: "pointer",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                />

                <ImageSelector
                  onImageSelect={handleImageSelect}
                  imageUrl={productImgUrl}
                  disabled={inputDisble}
                />
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate(-1)}
            >
              Cancel
            </MaterialButton>
            {!inputDisble && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleSubmit}
                disabled={!checkAllFields()}

              >
                {formType == "add" ? "Submit" : "update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default ManageComplaintsForms;
